import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import es from './locales/es.json';
import en from './locales/en.json';
import ca from './locales/ca.json';

// Available languages in the app
const availableLocales = ['es', 'en', 'ca'];

// Detect browser locale with sensible fallbacks
const detectBrowserLocale = () => {
  try {
    const browserLocales = (navigator.languages && navigator.languages.length
      ? navigator.languages
      : [navigator.language])
      .filter(Boolean)
      .map(l => (typeof l === 'string' ? l.toLowerCase() : ''));

    for (const locale of browserLocales) {
      // Prefer exact match like 'es', 'en', 'ca'
      if (availableLocales.includes(locale)) return locale;
      // Fallback to base language part e.g., 'es' from 'es-ES'
      const base = locale.split('-')[0];
      if (availableLocales.includes(base)) return base;
    }
  } catch (_) {}
  return 'en';
};

// Get initial locale from localStorage or browser detection (fallback to 'en')
const savedLocale = localStorage.getItem('locale') || detectBrowserLocale();

i18n
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
      ca: { translation: ca }
    },
    lng: savedLocale,
    fallbackLng: 'en',
    supportedLngs: availableLocales,
    interpolation: {
      escapeValue: false // React already escapes
    },
    react: {
      useSuspense: false
    }
  });

export default i18n;
